export default __webpack_public_path__ + "static/bg_default-ea0e12b5df15f955f309b7bf20e5c645.jpg";